import { render } from "./SpinnerComp.vue?vue&type=template&id=52c37e40&scoped=true"
import script from "./SpinnerComp.vue?vue&type=script&lang=js"
export * from "./SpinnerComp.vue?vue&type=script&lang=js"

import "./SpinnerComp.vue?vue&type=style&index=0&id=52c37e40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c37e40"]])

export default __exports__